(function(){
  if(window.__ccaLoaded)return;
  window.__ccaLoaded=true;
  'use strict';
  var STOREFRONT_TOKEN='7fad72fcbf356bf1370aaa6bb446b9d8';
  var API_VERSION='2024-01';
  var STOREFRONT_URL=window.location.origin+'/api/'+API_VERSION+'/graphql.json';
  var VARIANT_SCAN_LIMIT=15;

  var QUERY='query CollectionQuickAdd($id:ID!){node(id:$id){... on Product{id title handle availableForSale variants(first:'+VARIANT_SCAN_LIMIT+'){nodes{id availableForSale selectedOptions{name value}}}}}}';

  function toGid(numericId){return 'gid://shopify/Product/'+numericId;}
  function fromGid(gid){var parts=(gid||'').split('/');return parts[parts.length-1];}

  var STYLE_ID='cca-style';
  function ensureStyle(){
    if(document.getElementById(STYLE_ID))return;
    var style=document.createElement('style');
    style.id=STYLE_ID;
    style.textContent='@media (min-width:768px){.collection-quick-add{display:none;}}'+
      '.image-cont{position:relative;}'+
      '.collection-quick-add{position:absolute;bottom:8px;right:8px;width:38px;height:38px;border-radius:50%;border:none;background:#8E5E38;color:#ffffff;font-size:20px;font-weight:600;line-height:1;display:flex;align-items:center;justify-content:center;cursor:pointer;box-shadow:0 2px 6px rgba(0,0,0,0.25);z-index:2;padding:0;}'+
      '.collection-quick-add:active{background:#734a2c;}'+
      '.collection-quick-add[aria-disabled="true"]{opacity:0.5;pointer-events:none;}'+
      '.cca-popover{position:absolute;bottom:50px;right:8px;background:#fff;border:1px solid #d8cfc7;box-shadow:0 2px 10px rgba(0,0,0,0.15);padding:10px;z-index:3;width:180px;max-width:70vw;}'+
      '.cca-popover-close{position:absolute;top:4px;right:6px;background:none;border:none;font-size:14px;cursor:pointer;color:#80756d;}'+
      '.cca-group{margin-top:6px;}'+
      '.cca-group-label{font-size:9px;letter-spacing:1px;text-transform:uppercase;color:#80756d;margin-bottom:4px;}'+
      '.cca-pills{display:flex;flex-wrap:wrap;gap:4px;}'+
      '.cca-pill{border:1px solid #d8cfc7;background:#fff;font-size:10px;padding:4px 8px;cursor:pointer;font-family:inherit;}'+
      '.cca-pill.is-selected{background:#2a2623;color:#fff;border-color:#2a2623;}';
    document.head.appendChild(style);
  }

  ensureStyle();

  var currentPopover=null;
  var currentSeq=0;

  function closePopover(){
    if(currentPopover){currentPopover.remove();currentPopover=null;}
  }

  function addVariant(variantId,btn){
    btn.setAttribute('aria-disabled','true');
    fetch('/cart/add.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:variantId,quantity:1})
    })
      .then(function(r){return r.json().then(function(json){return {ok:r.ok,json:json};});})
      .then(function(result){
        if(!result.ok){btn.removeAttribute('aria-disabled');return;}
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        closePopover();
      })
      .catch(function(){btn.removeAttribute('aria-disabled');});
  }

  function openSelector(btn,availableVariants){
    closePopover();
    var block=btn.closest('.product-block');
    var anchor=block?block.querySelector('.image-cont'):btn.parentElement;
    if(!anchor)anchor=btn.parentElement;

    var optionNames=[];
    (availableVariants[0].selectedOptions||[]).forEach(function(o){optionNames.push(o.name);});

    function filteredBy(selections){
      return availableVariants.filter(function(v){
        return optionNames.every(function(name){
          if(!(name in selections))return true;
          var opt=(v.selectedOptions||[]).filter(function(o){return o.name===name;})[0];
          return opt&&opt.value===selections[name];
        });
      });
    }

    var selections={};
    optionNames.forEach(function(name){
      var values={};
      availableVariants.forEach(function(v){
        var opt=(v.selectedOptions||[]).filter(function(o){return o.name===name;})[0];
        if(opt)values[opt.value]=true;
      });
      var uniqueValues=Object.keys(values);
      if(uniqueValues.length===1){selections[name]=uniqueValues[0];}
    });

    var groupsToRender=optionNames.filter(function(name){return !(name in selections);});

    var pop=document.createElement('div');
    pop.className='cca-popover';
    anchor.appendChild(pop);
    currentPopover=pop;

    function render(){
      var html='<button type="button" class="cca-popover-close" aria-label="Close">&times;</button>';
      groupsToRender.forEach(function(name){
        var others=Object.assign({},selections);
        delete others[name];
        var candidates=filteredBy(others);
        var seen={};
        var ordered=[];
        candidates.forEach(function(v){
          var opt=(v.selectedOptions||[]).filter(function(o){return o.name===name;})[0];
          if(opt&&!seen[opt.value]){seen[opt.value]=true;ordered.push(opt.value);}
        });
        html+='<div class="cca-group" data-option-name="'+name.replace(/"/g,'&quot;')+'">'+
          '<div class="cca-group-label">'+name.replace(/</g,'&lt;')+'</div>'+
          '<div class="cca-pills">';
        ordered.forEach(function(val){
          var isSelected=selections[name]===val;
          html+='<button type="button" class="cca-pill'+(isSelected?' is-selected':'')+'" data-value="'+val.replace(/"/g,'&quot;')+'">'+val.replace(/</g,'&lt;')+'</button>';
        });
        html+='</div></div>';
      });
      pop.innerHTML=html;

      pop.querySelector('.cca-popover-close').addEventListener('click',function(evt){
        evt.preventDefault();
        closePopover();
      });

      groupsToRender.forEach(function(name){
        var groupEl=pop.querySelector('[data-option-name="'+name.replace(/"/g,'\\"')+'"]');
        if(!groupEl)return;
        groupEl.querySelectorAll('.cca-pill').forEach(function(pillEl){
          pillEl.addEventListener('click',function(){
            selections[name]=pillEl.dataset.value;
            var resolved=filteredBy(selections);
            var allChosen=groupsToRender.every(function(n){return n in selections;});
            if(allChosen&&resolved.length===1){
              addVariant(fromGid(resolved[0].id),btn);
              return;
            }
            render();
          });
        });
      });
    }

    render();
  }

  document.addEventListener('click',function(evt){
    var closeBtn=evt.target.closest('.cca-popover-close');
    if(closeBtn)return;

    var btn=evt.target.closest('.collection-quick-add');
    if(!btn){
      if(currentPopover&&!evt.target.closest('.cca-popover')){
        closePopover();
      }
      return;
    }
    evt.preventDefault();
    if(btn.getAttribute('aria-disabled')==='true')return;

    var productId=btn.dataset.productId;
    var mySeq=++currentSeq;

    btn.setAttribute('aria-disabled','true');

    fetch(STOREFRONT_URL,{
      method:'POST',
      headers:{'Content-Type':'application/json','X-Shopify-Storefront-Access-Token':STOREFRONT_TOKEN},
      body:JSON.stringify({query:QUERY,variables:{id:toGid(productId)}})
    })
      .then(function(r){return r.json();})
      .then(function(data){
        btn.removeAttribute('aria-disabled');
        if(mySeq!==currentSeq)return;
        if(data&&data.errors){console.warn('Collection Quick Add GraphQL error',data.errors);return;}
        if(!data||!data.data||!data.data.node)return;
        var product=data.data.node;
        var availableVariants=(product.variants&&product.variants.nodes||[]).filter(function(vv){return vv&&vv.availableForSale===true;});
        if(availableVariants.length===0)return;
        if(availableVariants.length===1){
          addVariant(fromGid(availableVariants[0].id),btn);
          return;
        }
        openSelector(btn,availableVariants);
      })
      .catch(function(err){
        btn.removeAttribute('aria-disabled');
        if(mySeq!==currentSeq)return;
        console.warn('Collection Quick Add fetch error',err);
      });
  });
})();
